import React, {Component, createRef} from 'react';
import {gsap} from 'gsap'
import mac from '../../Resources/Twitch.png'
import './Scene5.css';
import MaxButton from "../MaxButton";
import {FormattedMessage} from "react-intl";
import {ch, cw} from "../../Utilities/utils";

const scene5 = createRef();

class Scene5 extends Component<> {
    constructor(props) {
        super(props);
        this.line1 = createRef();
        this.line2 = createRef();
        this.underlined1 = createRef();
        this.underlined2 = createRef();
        this.container = createRef();
    }

    componentDidMount()  {
        let xu = document.getElementById('s4bg1V').getAttribute('x1');
        let yu = document.getElementById('s4bg1H').getAttribute('y1');
        let line1Top = ch(this.underlined1, this.container);
        let line2Top = ch(this.underlined2, this.container);

        gsap.timeline({
            scrollTrigger: {
                trigger: scene5.current,
                start: 'top top',
                end: '+=100%',
                scrub: true,
                pin: '#scene5',
//                toggleActions: 'play complete restart reverse',
            }
        }).from(scene5.current, {
            duration: 0.01,
            zIndex: 0,
        }, '1').to(['#s4gcV','#s4gcH'], {
            duration: 2,
            attr:{x1: '-=' + xu, x2: '-=' + xu},
        }, '0')
        .to(['#s4rcV', '#s4rcH'],{
            duration: 2,
            opacity: 0,
            attr:{y1: '+=' + yu*2, y2: '+=' + yu*2},
        }, '0')
        .from(['#s4ocV', '#s4ocH'], {
            duration: 3,
            opacity: 0,
            attr:{x1: '-=' + xu*2, x2: '-=' + xu*2},
        }, '0')
        .from(".s5-mac-container", {
            opacity: 1,
            duration: 4.2,
            x: "-70vw",
        }, '0')
        .to(".s5-mac-container", {
            opacity: 1,
            duration: 2,
            left: "12vw",
            width: "70vw",
        }, "4.6")
        .to(".s5-mac-container", {
            duration: 2,
            y: "-=90vh",
        }, '6.5')
        .from('.s5-text', {
            opacity: 0.5,
            x: "100vw",
            stagger: .15,
            repeat: 1,
            repeatDelay: 1.5,
            yoyo: true,
            duration: 2,
        }, "0")
        .fromTo(this.line1.current, {
            opacity: 0,
            width: 0,
            top: line1Top,
        }, {
            opacity: 1,
            width: cw(this.underlined1, this.container, 'right'),
            top: line1Top,
            repeat: 1,
            repeatDelay: 1.5,
            yoyo: true,
            duration: 2,
        }, "1")
        .fromTo(this.line2.current, {
            opacity: 0,
            width: 0,
            top: line2Top,
        }, {
            opacity: 1,
            width: cw(this.underlined2, this.container, 'right'),
            top: line2Top,
            repeat: 1,
            repeatDelay: 1.5,
            yoyo: true,
            duration: 2,
        }, "1");
    }

    render() {
        return (
            <section ref={scene5} className='s5-container'>
                <div id={'scene5'} className='content'>
                    <div className={'s5-mac-container'}>
                        <img src={mac} className={"s5-mac accessibility-img"} alt={'Notebook'}/>
                    </div>
                    <div ref={this.line1} className={'underline right purple accessibility-line'}/>
                    <div ref={this.line2} className={'underline right purple accessibility-line'}/>
                    <div ref={this.container} className={'s5-text-container clip-all'}>
                        <h2><span className={'s5-text'}><FormattedMessage id={"home_experiences_title"}/></span></h2>
                        <h1>
                            <span className={"s5-text"}><FormattedMessage id={"home_experiences_txt"}/></span>
                            <span className={"s5-text"} ref={this.underlined1}>
                                <FormattedMessage id={"home_experiences_txt_2"}/>
                            </span>
                            <span className={"s5-text"} ref={this.underlined2}>
                                <FormattedMessage id={"home_experiences_txt_3"}/>
                            </span>
                            <span className={"s5-text"}><FormattedMessage id={"home_experiences_txt_4"}/></span>
                            <span className={"s5-text"}><FormattedMessage id={"home_experiences_txt_5"}/></span>
                        </h1>
                        <div className={'s5-text right'}>
                            <MaxButton clickRoute={'services/gaming'}>
                                home_learn_more_button
                            </MaxButton>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default Scene5;
